export default __webpack_public_path__ + "static/review-img-lg-acd958d9df826a706d8adaa43228d58b.png";